import cx from 'classnames'
import * as React from 'react'
import { CSSProperties } from 'react'

import { GtagEvent } from '@/utils/gtag'

import Anchor from '../../components/Anchor/Anchor'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Icon from '../Icon/Icon'
import stylesCss from './link-style.css'

type Props = LinkViewModel & {
  children?: React.ReactNode
  className?: string
  secondary?: boolean
  noUnderline?: boolean
  hoverArrow?: boolean
  eventMeta?: GtagEvent
  styles?: CSSProperties
  darkBg?: boolean
}
type State = {}

class Link extends React.Component<Props, State> {
  static displayName = 'Link'
  static defaultProps = {
    secondary: false,
    theme: 'dark',
  }

  render() {
    const {
      children,
      secondary,
      className,
      noUnderline,
      hoverArrow,
      styles,
      darkBg,
      ...rest
    } = this.props

    return (
      <Anchor
        className={cx(
          !secondary ? stylesCss.primary : stylesCss.secondary,
          className,
          noUnderline && stylesCss.noUnderline,
          hoverArrow && stylesCss.hoverArrow,
          darkBg && stylesCss.darkBg,
        )}
        styles={styles}
        {...rest}
      >
        {children}
        {hoverArrow && (
          <div className={stylesCss.arrowHolder}>
            <Icon iconName="ArrowRight" className={stylesCss.arrow} />
            <Icon iconName="ArrowRight" className={stylesCss.arrow} />
          </div>
        )}
      </Anchor>
    )
  }
}

export default Link
